/**
 * initMainMenu initializes the behaviour of WP menus (clicking links to reveal to submenus etc.).
 * 
 * Note that appropriate CSS must be in place - see _main-menu-popup.scss.
 */

declare const jQuery: any;
const $ = jQuery;

// $wrap - JQuery object - container element for ul.menu (not the ul.menu itself).
// To make submenus open on mouse hover, add the class "open-submenu-on-hover" to
// $wrap before passing it here.
export function initMainMenu($wrap): void
{
	if ($wrap.length === 0)
	{
		return;
	}

	const openSubmenuOnHover: boolean = $wrap.is(".open-submenu-on-hover");
	const $menu = $wrap.find("ul.menu");
	const $allLinks = $menu.find("a");
	const $itemsWithChildren = $menu.find("li.menu-item-has-children");
	const $links = $itemsWithChildren.children("a");
	const $submenus = $wrap.find("ul.sub-menu");
	
	const onClick = function onClick(e) {
		const $link = $(this);
		const $submenu = $link.parent().children("ul.sub-menu");
		const href: string = $link.attr("href");
		const hasPage: boolean = href && href[0] !== "#";
		if (hasPage && $link.hasClass("always-follow"))
		{
			// follow link
			return;
		}
		const isOpen: boolean = $submenu.hasClass("open");
		if (isOpen && hasPage) {
			// follow link
			return;
		}
		e.preventDefault();
		if (!isOpen) {
			// open submenu
			const $ancestorSubmenus = $submenu.parents("ul.sub-menu");
			$submenus.not($ancestorSubmenus).removeClass("open");
			$submenu.addClass("open").trigger("open");
			$allLinks.removeClass("open");
			$submenu.closest("li").children("a").addClass("open");
			return false;
		}
		// close submenu
		const $descendentSubmenus = $link.parent().find("ul.sub-menu");
		$submenu.add($descendentSubmenus).removeClass("open").trigger("close");
		return false;
	};
	const onMouseLeave = function onMouseLeave(e) {
		const $link = $(this);
		const $submenu = $link.parent().children("ul.sub-menu");
		const $descendentSubmenus = $link.parent().find("ul.sub-menu");
		$submenu.add($descendentSubmenus).removeClass("open").trigger("close");
		e.stopPropagation();
		return false;
	};
	$links.add("body").one("touchstart", (e) => {
		$links.off("click mouseenter", onClick).on("click", onClick);
		$itemsWithChildren.off("mouseleave", onMouseLeave);
	});
	$menu.on("close", function (e) {
		e.stopPropagation(); // prevent popup being closed
	});
	$links.on(openSubmenuOnHover ? "mouseenter" : "click", onClick);
	if (openSubmenuOnHover) {
		$itemsWithChildren.on("mouseleave", onMouseLeave);
	}
}

if (!window["iw"])
{
    window["iw"] = {};
}

window["iw"].initMainMenu = initMainMenu;
